import { Children, cloneElement, isValidElement, ReactHTMLElement, ReactNode } from 'react';
import { RadioButton } from '../RadioButton/RadioButton';
import { joinClassNames } from '../../../utils';
import styles from './styles.module.scss';

export type RadioButtonGroupProps = {
  children: ReactNode;
  name: string;
  value: string;
  className?: string;
  hasError?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const isRadioButtonInputElement = (element: ReactNode): element is ReactHTMLElement<HTMLInputElement> => {
  return isValidElement(element) && element.type === RadioButton;
};

export const RadioButtonGroup = ({
  children,
  name,
  value,
  className,
  hasError,
  disabled,
  onChange,
}: RadioButtonGroupProps) => (
  <div className={joinClassNames(styles.radioButtonGroup, className)}>
    {Children.map(children, (child) => {
      if (isRadioButtonInputElement(child)) {
        return cloneElement(child, {
          ...child.props,
          name,
          checked: value === child.props.value,
          onChange: (e) => onChange(e.currentTarget.value),
          hasError,
          disabled: disabled || child.props.disabled,
        });
      }

      return child;
    })}
  </div>
);

RadioButtonGroup.displayName = 'RadioButtonGroup';
